import { Injectable } from '@angular/core';

  

import { ToastrService } from 'ngx-toastr';

  

@Injectable({

  providedIn: 'root'

})

export class NotificationService {

  

  constructor(private toastr: ToastrService) { }

  

  showSuccess(message:any, title:any){

      this.toastr.success(message, title, {
        positionClass : 'toast-top-center'
      })

  }

  

  showError(message:any, title:any){

      this.toastr.error(message, title, {
        positionClass : 'toast-top-center'
      } )

  }

  

  showInfo(message:any, title:any){

      this.toastr.info(message, title, {
        positionClass : 'toast-top-center'
      })
  }

  showInfoLonger(message:any, title:any){
    this.toastr.info(message, title, {
      timeOut: 20000,
      positionClass : 'toast-top-center'
    })
  }

  showInfoCenter(message:any, title:any){
      this.toastr.info(message, title, {
        positionClass : 'toast-top-center'
      })
  }

showSuccessLonger(message:any, title:any){

  this.toastr.success(message, title, {
    timeOut: 20000,
    positionClass : 'toast-top-center'
  })

}

  

  showWarning(message:any, title:any){

      this.toastr.warning(message, title)

  }

  

}